/**
 * Application Constants
 */

// API Configuration
export const API_TIMEOUT = 30000; // 30 seconds

// Routes
export const ROUTES = {
  LOGIN: '/login',
  INPUTS: '/inputs',
  OUTPUT: {
    MAGNETIC: '/output_magnetic',
    ACOUSTIC: '/output_acoustic',
    SEISMIC: '/output_seismic',
  },
  ADMIN: '/admin',
  SYSTEMS: {
    NEW: '/new_system',
    EDIT: '/edit_system',
  },
};

// Distortion Types
export const DISTORTION_TYPES = {
  MAGNETIC: 'magnetic',
  ACOUSTIC: 'acoustic',
  SEISMIC: 'seismic',
};

// Axis Types
export const AXIS_TYPES = {
  X: 'x',
  Y: 'y',
  Z: 'z',
  XY: 'xy',
  XYZ: 'xyz',
};

// File Types
export const FILE_TYPES = {
  CSV: 'text/csv',
  ZIP: 'application/zip',
  PDF: 'application/pdf',
  JSON: 'application/json',
  TXT: 'text/plain',
};

// Max File Sizes (in MB)
export const MAX_FILE_SIZES = {
  CSV: 50,
  ZIP: 150,
  VIDEO: 500,
  IMAGE: 10,
};

// Status Messages
export const STATUS_MESSAGES = {
  SUCCESS: 'Operation completed successfully',
  ERROR: 'An error occurred. Please try again',
  LOADING: 'Loading...',
  PROCESSING: 'Processing...',
  FILE_TOO_LARGE: 'File size exceeds the limit',
  INVALID_FILE_TYPE: 'Invalid file type',
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection',
  SERVER_ERROR: 'Server error. Please try again later',
  UNAUTHORIZED: 'Session expired. Please log in again',
  FORBIDDEN: 'You do not have permission to perform this action',
  NOT_FOUND: 'The requested resource was not found',
  VALIDATION_ERROR: 'Please check your input and try again',
  FILE_UPLOAD_ERROR: 'File upload failed',
  SIMULATION_ERROR: 'Simulation failed. Please try again',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  SESSION_ID: 'session_id',
  USER_DATA: 'user_data',
  PREFERENCES: 'app_preferences',
  CACHE: 'app_cache',
};

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [5, 10, 25, 50, 100],
};

// Time Constants (in milliseconds)
export const TIME = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,
};

// Debounce/Throttle Delays (in milliseconds)
export const DELAYS = {
  SHORT: 300,
  MEDIUM: 500,
  LONG: 1000,
};

// Theme Colors
export const THEME_COLORS = {
  PRIMARY: '#1976d2',
  SECONDARY: '#dc004e',
  SUCCESS: '#4caf50',
  ERROR: '#f44336',
  WARNING: '#ff9800',
  INFO: '#2196f3',
};

// Environment
export const ENVIRONMENT = process.env.NODE_ENV || 'development';
export const IS_DEVELOPMENT = ENVIRONMENT === 'development';
export const IS_PRODUCTION = ENVIRONMENT === 'production';

export default {
  API_TIMEOUT,
  ROUTES,
  DISTORTION_TYPES,
  AXIS_TYPES,
  FILE_TYPES,
  MAX_FILE_SIZES,
  STATUS_MESSAGES,
  ERROR_MESSAGES,
  STORAGE_KEYS,
  PAGINATION,
  TIME,
  DELAYS,
  THEME_COLORS,
  ENVIRONMENT,
  IS_DEVELOPMENT,
  IS_PRODUCTION,
};
